<template>
  <!-- end of row -->
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="$t('online_session.online_session')" active>
              <data-table :edit-item="editItem" />
            </b-tab>
            <b-tab @click="newItem= {}" :title="$t('site.add')" v-if="usertype=='admin'" >
              <my-form :new-item="newItem" />
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import Auth from '@/Apis/Auth';
import DataTableVue from "./components/DataTable.vue";
import FormVue from "./components/Form.vue";

export default {
  name: "OnlineSessionIndex",
  components: {
    "data-table": DataTableVue,
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tab: 0,
      usertype:Auth.USER.account_type
    };
  },
  created(){
    this.$mobileTitle.label=this.$i18n.t('online_session.online_session'); 

  },
  methods: {
    editItem(data) {
      this.newItem = data.item;
      this.tab = 1;
    },
  },
};
</script>
